export default __webpack_public_path__ + "static/media/HandballWorldCupLogoWithBG.69ca08c1.png";